import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';


import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Device } from '@ionic-native/device';
import { KeychainTouchId } from '@ionic-native/keychain-touch-id';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { Geolocation } from '@ionic-native/geolocation';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Deeplinks } from '@ionic-native/deeplinks';

// BARELLS
//import { UrlConstsants, API_ENDPOINTS } from '../commons/constants';
import {
    EventsService, TicketsService, TokenService, HttpHelperService,
    LocalStorageService, PlatformService, LoggingService, NotificationsService,
    PriceService, StripeService, AccountService, Confirmation,
    ValidationService, FcmService, SecureStorageService, TimeService, FaqService,SettingsService

} from '@varsity/services';
import {
    ComponentsModule, LoginComponent, RecoverPasswordComponent,
    ValidateTicketsComponent, DisplayMessageComponent, SportFilterComponent,
    PromoCodeComponent, DateFilterComponent, TransferTicketsComponent, TicketActionsComponent, CustomFormsComponent, TextTicketsComponent,
    PriceSelectionComponent, StadiumSectionMapPopoverComponent
} from '@varsity/components';

// removed as this one uses the deprecated UIWebView https://github.com/passslot/cordova-plugin-passbook
// https://cordova.apache.org/announcements/2019/12/02/cordova-ios-release-5.1.1.html
//import { passbook } from 'node_modules/cordova-plugin-passbook/doc';

// maybe use this ??
// https://github.com/yinzara/cordova-plugin-passbook

// import * as API_Endpoints from '../commons/constants/api-endpoints';


// Firebase related imports
import { Firebase } from '@ionic-native/firebase';

import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';

//const firebase = {
//    apiKey: "AIzaSyAjCb4CMyQbuvlaWb5NaQuZmx54lSRn058",
//    authDomain: "varsitytix-4a99b.firebaseapp.com",
//    databaseURL: "https://varsitytix-4a99b.firebaseio.com",
//    projectId: "varsitytix-4a99b",
//    storageBucket: "varsitytix-4a99b.appspot.com",
//    messagingSenderId: "911734836424"
//}

const firebaseProd = {
    apiKey: "AIzaSyBgv62QORVz9C-OZEk5dn8UBttC0yOcxpA",
    authDomain: "varsitytix-821db.firebaseapp.com",
    databaseURL: "https://varsitytix-821db.firebaseio.com",
    projectId: "varsitytix-821db",
    storageBucket: "varsitytix-821db.appspot.com",
    messagingSenderId: "567714823082"
}

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        IonicModule.forRoot(AppComponent),
        //{
        //    locationStrategy: 'path'
        //}),
        HttpModule,
        ComponentsModule,
        AngularFireModule.initializeApp(firebaseProd),
        AngularFirestoreModule,
        BrowserAnimationsModule
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        AppComponent,
        LoginComponent, // components that are shown in popover need to be here
        SportFilterComponent,
        DateFilterComponent,
        RecoverPasswordComponent,
        ValidateTicketsComponent,
        TransferTicketsComponent,
        TextTicketsComponent,
        DisplayMessageComponent,
        CustomFormsComponent,
        PromoCodeComponent,
        PriceSelectionComponent,
        StadiumSectionMapPopoverComponent
    ],
    providers: [
        Device,
        StatusBar,
        SplashScreen,
        KeychainTouchId,
        InAppBrowser,
        { provide: ErrorHandler, useClass: IonicErrorHandler },
        TicketsService,
        StripeService,
        EventsService,
        TokenService,
        AccountService,
        HttpHelperService,
        LocalStorageService,
        PlatformService,
        SecureStorageService,
        LoggingService,
        NotificationsService,
        PriceService,
        TimeService,
        ValidationService,
        Firebase,
        FcmService,
        Geolocation,
        Deeplinks,
        FaqService,
        SettingsService
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts